import * as React from "react";
import { forwardRef } from "react";
const SvgCheckList2 = (props, ref) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 100 100"
    ref={ref}
    {...props}
  >
    <path d="M4.015 70.278v16.223h16.223V70.278Zm2.704 2.704h10.815v10.815H6.72zM22.536 39.91c-3.745 1.302-7.32 4.788-10.082 6.85-3.738-2.065-6.408-6.036-10.157-6.847-2.271.118-3.119 3.034-1.267 4.352 0 0 3.684 2.715 7.431 5.506-2.944 2.021-5.42 4.293-7.82 6.949-2.112 2.406 1.496 5.573 3.608 3.167 2.442-2.917 5.217-4.872 8.205-7.116 2.987 2.083 5.724 4.37 8.204 7.116 2.112 2.407 5.719-.762 3.609-3.167-2.449-2.817-5.088-4.895-7.823-6.951 3.748-2.79 7.433-5.504 7.433-5.504 1.883-1.34.97-4.306-1.34-4.356M35.819 81.093H100v-4.055H35.819Z" />
    <path d="M4.015 41.888v16.223h16.223V41.888Zm2.704 2.704h10.815v10.815H6.72zM35.819 52.704H100v-4.056H35.819ZM4.015 13.498v16.223h16.223V13.498Zm2.704 2.704h10.815v10.815H6.72zM35.819 24.314H100v-4.056H35.819Z" />
  </svg>
);
const ForwardRef = forwardRef(SvgCheckList2);
export default ForwardRef;
